"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundStyleManager = void 0;
var defaultStyles_1 = require("@CommonFrontend/Styles/BlockStyles/defaultStyles");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var BlockStore_1 = __importDefault(require("Project/Stores/BlockStore"));
var inversify_1 = require("inversify");
var lodash_1 = require("lodash");
var DEFAULTS = {
    abs: utils_1.DEFAULT_WHITE.value,
    themeIndex: utils_1.DEFAULT_WHITE.themeIndex,
    opacity: 1,
    url: undefined,
    videoThumbnail: undefined,
    tintColor: defaultStyles_1.defaultRgbaColor,
    tintBlendMode: "normal",
    blur: 0,
    card: {
        enabled: false,
        color: defaultStyles_1.defaultRgbaColor,
    },
};
var BackgroundStyleManager = (function () {
    function BackgroundStyleManager(blockStore) {
        this.blockStore = blockStore;
        this.cachedStyles = {};
    }
    BackgroundStyleManager.prototype.swapTo = function (type) {
        var blockStyle = this.blockStore.blockStyleStore.model;
        if (blockStyle.background.type === type)
            return;
        this.cachedStyles[blockStyle.background.type] = (0, lodash_1.pick)(blockStyle.background, Object.keys(DEFAULTS));
        this.blockStore.blockStyleStore.setStylePropsByKey("background", __assign(__assign(__assign(__assign({}, blockStyle.background), { type: type }), DEFAULTS), this.cachedStyles[type]));
    };
    BackgroundStyleManager.prototype.setBackgroundProperties = function (background) {
        if (!!background.type) {
            this.swapTo(background.type);
        }
        var blockStyle = this.blockStore.blockStyleStore.model;
        var newBackground = (0, lodash_1.merge)({}, blockStyle.background, background);
        this.blockStore.blockStyleStore.setStylePropsByKey("background", newBackground);
    };
    var _a;
    BackgroundStyleManager = __decorate([
        (0, inversify_1.injectable)(),
        __param(0, (0, inversify_1.inject)("blockStore")),
        __metadata("design:paramtypes", [typeof (_a = typeof BlockStore_1.default !== "undefined" && BlockStore_1.default) === "function" ? _a : Object])
    ], BackgroundStyleManager);
    return BackgroundStyleManager;
}());
exports.BackgroundStyleManager = BackgroundStyleManager;
